import { render, staticRenderFns } from "./SpecificRequestReviewer.vue?vue&type=template&id=66886e4d&scoped=true"
import script from "./SpecificRequestReviewer.vue?vue&type=script&lang=js"
export * from "./SpecificRequestReviewer.vue?vue&type=script&lang=js"
import style0 from "./SpecificRequestReviewer.vue?vue&type=style&index=0&id=66886e4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66886e4d",
  null
  
)

export default component.exports